if (!customElements.get('leslis-journal')) {
  customElements.define('leslis-journal', class extends HTMLElement {
    connectedCallback() {
      const filters = this.querySelector('.leslis-journal__filters');
      if (!filters || this.controller) return;
      this.controller = new AbortController();
      const cards = Array.from(this.querySelectorAll('[data-journal-card]'));
      const buttons = Array.from(filters.querySelectorAll('[data-journal-filter]'));
      buttons.forEach(button => {
        if (button.dataset.journalFilter !== 'all' && !cards.some(card => card.dataset.topic === button.dataset.journalFilter)) button.hidden = true;
      });
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-journal-filter]');
        if (!button) return;
        const topic = button.dataset.journalFilter;
        let count = 0;
        cards.forEach(card => {
          card.hidden = topic !== 'all' && card.dataset.topic !== topic;
          if (!card.hidden) count++;
        });
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelector('[data-journal-status]').textContent = count === 1 ? this.dataset.countOne : this.dataset.countLabel.replace('[count]', count);
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
